import { productFruits } from 'product-fruits'

const WORKSPACE_CODE = 'QaPm9Dc29N18z3UY'
const SUPPORT_SOURCE_LANGUAGE = ['en', 'es', 'br']

function salesProfileUserTypeAllowed (userTypeInfo = {}) {
  const { salesProfileUserType } = userTypeInfo
  return ['producer', 'coproducer', 'hybrid'].includes(salesProfileUserType?.toLowerCase())
}

function start (user) {
  const { email, locale } = user || {}
  if (!email) {
    return
  }
  const isSalesProfileAllowed = salesProfileUserTypeAllowed(user?.userTypeInfo)
  if (!isSalesProfileAllowed) {
    return
  }
  const userData = {
    username: email,
    email
  }
  const localeFormat = (locale.length > 2 ? locale?.substring(3, 5) : locale)?.toLowerCase()
  const sourceLanguage = SUPPORT_SOURCE_LANGUAGE.includes(localeFormat) ? localeFormat : 'en'

  productFruits.init(WORKSPACE_CODE, sourceLanguage, userData)
}

export default {
  start
}
